import styled from 'styled-components';

export const StyledItem = styled.img`
  max-width: fit-content;
  max-height: ${({ theme }) => theme.spacing(16)};
  border-radius: ${({ theme }) => theme.spacing(1)};
`;

// Hiding this for card: BTCOBUI-4350
// const getButtonStatusColor = (color: Color, statusType: StockStatusType, mode: ThemeMode) => {
//   const lightModeColors = {
//     Picked: color.secondaryDarkTextGray,
//     Pick: color.red,
//     NotFound: color.validationGreen,
//   };

//   const darkModeColors = {
//     Picked: color.borderGrayDark,
//     Pick: color.error,
//     NotFound: color.successLight,
//   };

//   const modeColors = mode === 'light' ? lightModeColors : darkModeColors;

//   return modeColors[statusType];
// };

// Hiding this for card: BTCOBUI-4350
// export const StyledIconWithText = styled(IconWithText)<{ statusType: StockStatusType }>`
//   width: max-content;
//   cursor: ${({ statusType }) => (statusType === 'Picked' ? 'not-allowed' : 'pointer')};

//   & > div {
//     color: ${({ theme: { color, palette }, statusType }) => getButtonStatusColor(color, statusType, palette.mode)};
//   }
//   &:active {
//     background-color: ${({ theme: { color, palette }, statusType }) =>
//       statusType !== 'Picked' && getButtonStatusColor(color, statusType, palette.mode)};

//     & > div {
//       color: ${({ theme: { color, palette }, statusType }) =>
//         statusType !== 'Picked' && (palette.mode === 'dark' ? color.backgroundDark : color.white)};
//     }
//   }
// `;
